export default __webpack_public_path__ + "static/media/dashboardIconAfterClick.9b19fc5d.svg";